import React from 'react';
import { Segmented } from 'antd';
import { useSearchParams } from 'react-router-dom';
import {
  CLAIMS_ARCHIVE_SCOPE_OPTIONS,
  getClaimsArchiveScope,
  normalizeClaimsArchiveScope,
} from './claimsArchiveHelpers';
import './ClaimsArchiveScopeBar.css';

/**
 * Active / Archived / All filter for claims drilldown lists.
 * Persists `scope` in the URL (defaults to active when omitted).
 */
export default function ClaimsArchiveScopeBar({ className = '' }) {
  const [searchParams, setSearchParams] = useSearchParams();
  const value = getClaimsArchiveScope(searchParams);

  const onChange = (next) => {
    const normalized = normalizeClaimsArchiveScope(next);
    const params = new URLSearchParams(searchParams);
    if (normalized === 'active') {
      params.delete('scope');
    } else {
      params.set('scope', normalized);
    }
    setSearchParams(params, { replace: true });
  };

  return (
    <div className={`claims-archive-scope-bar dash-tab-strip dash-tab-strip--compact ${className}`.trim()} role="tablist" aria-label="Claims archive scope">
      <Segmented
        value={value}
        onChange={onChange}
        options={CLAIMS_ARCHIVE_SCOPE_OPTIONS}
      />
      <p className="claims-archive-scope-bar__hint">
        {value === 'archived'
          ? 'Showing archived claims only — use Unarchive to restore them to active queues.'
          : value === 'all'
            ? 'Showing active and archived claims together.'
            : 'Showing active (non-archived) claims. Archived claims are hidden by default.'}
      </p>
    </div>
  );
}
